import { useEffect, useRef, useState } from 'react';
import useDocumentTitle from '../../../../hooks/useDocumentTitle';
import { GlobalService } from '../../../../services/GlobalService';
import { useNavigate, useParams } from 'react-router-dom';
import { useLoader } from '../../../../context/LoaderContext';
import { UserService } from '../../../../services/UserService';
import { ToasterService } from '../../../../services/ToasterService';
import { STATUS_SUCCESS } from '../../../../utils/constants';
type FormData = {
  // shopName: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  country: string;
  pincode: string;
  billingAddress: number;
};

type Errors = Partial<Record<keyof FormData, string>>;

export default function UseCreateUserAddressPage() {
  useDocumentTitle('Namasteji Manikchand - Create Address');
  const navigate = useNavigate();
  const getUserLoginData = localStorage.getItem('userLoginData');
  let parsedUserData: any = {};
  const [errors, setErrors] = useState<Errors>({});
  const [stateList, setStateList] = useState<string[]>([]);
  const [countryList, setCountryList] = useState<{ name: string }[]>([]);
  const newErrors: Errors = {};
  const { addressId }: any = useParams();
  const { setLoading } = useLoader();
  const pageTitle = useRef('Create New Address');
  const [wrongPincodeError, setWrongPincodeError] = useState<boolean>(false);
  const customerId = useRef<any>('');

  useEffect(() => {
    checkLogin();
    getState();
    getCountry();
  }, []);

  function checkLogin() {
    if (getUserLoginData) {
      parsedUserData = JSON.parse(getUserLoginData);
      if (parsedUserData && parsedUserData.customer_id) {
        customerId.current = parsedUserData.customer_id;
        if (addressId && addressId !== '') {
          pageTitle.current = 'Update Address';
          getAddressList(parsedUserData.customer_id, addressId);
        }
      } else {
        ToasterService.Error('Please Login Again');
        navigate('/login');
      }
    } else {
      navigate('/login');
    }
  }

  const [formData, setFormData] = useState({
    // shopName: "",
    address1: '',
    address2: '',
    city: '',
    state: '',
    country: 'India',
    pincode: '',
    shippingAddress: 0,
  });

  const getState = async () => {
    const resp = await GlobalService.State();
    setStateList(resp.message);
  };

  const getCountry = async () => {
    const resp = await GlobalService.Country();
    setCountryList(resp.message);
  };

  async function getAddressList(customerId: string, addressId: string) {
    try {
      setLoading(true);
      const resp = await UserService.GetSingleAddress(customerId, addressId);
      setLoading(false);
      if (resp && resp.message && resp.message.addresses && resp.message.addresses.length > 0) {
        const singleAddress = resp.message.addresses.find((addr: any) => addr.name === addressId);
        // console.log('resp.message.addresses ', singleAddress);
        const addressDataObj = singleAddress;
        // setAddressData(resp.message.addresses[0])
        // const addressDataObj = resp.message.addresses[0];
        setFormData({
          // shopName: addressDataObj.address_title ? addressDataObj.address_title : "",
          address1: addressDataObj.address_line1 ? addressDataObj.address_line1 : '',
          address2: addressDataObj.address_line2 ? addressDataObj.address_line2 : '',
          city: addressDataObj.city ? addressDataObj.city : '',
          state: addressDataObj.state ? addressDataObj.state : '',
          country: addressDataObj.country ? addressDataObj.country : '',
          pincode: addressDataObj.pincode ? addressDataObj.pincode : '',
          shippingAddress: addressDataObj.is_shipping_address ? addressDataObj.is_shipping_address : 0,
        });
      }
    } catch (err) {
      setLoading(false);
      ToasterService.Error('Server Error!..');
    }
  }

  const handleChange = (e: any) => {
    const { name, value, type, checked } = e.target;
    if (name === 'pincode' && wrongPincodeError) {
      setWrongPincodeError(false);
    }
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : value,
    }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validate = (): boolean => {
    // if (!formData.shopName.trim()) {
    //     newErrors.shopName = "Shop Name is required";
    // }
    if (!formData.address1.trim()) {
      newErrors.address1 = 'Address-1 is required';
    }
    if (!formData.address2.trim()) {
      newErrors.address2 = 'Address-2 is required';
    }
    if (!formData.city.trim()) {
      newErrors.city = 'City is required';
    }
    if (!formData.state.trim()) {
      newErrors.state = 'Please select State';
    }
    if (!formData.country.trim()) {
      newErrors.country = 'Please select Country';
    }
    const pincode = formData.pincode.trim();
    if (!pincode) {
      newErrors.pincode = 'Pinocode is required';
    } else if (pincode.length !== 6) {
      newErrors.pincode = 'Pincode Must be exactly 10 digits';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      if (addressId && addressId !== '') {
        const payload = {
          address_id: addressId,
          address_line_1: formData.address1,
          address_line_2: formData.address2,
          city: formData.city,
          state: formData.state,
          pincode: formData.pincode,
          country: formData.country,
          //    ...(String(formData.billingAddress) === '1' && {
          //   is_primary_address: '1',
          // }),
          ...(String(formData.shippingAddress) === '1' && {
            is_shipping_address: '1',
          }),
        };
        const resp = await UserService.UpdateAddress(payload);
        if (resp && resp.message && resp.message.status === STATUS_SUCCESS) {
          ToasterService.Success('Address Updated Successfully!.');
          navigate(-1);
        } else if (resp?.exception && resp.exception.includes('Postal Code')) {
          setWrongPincodeError(true);
        } else {
          ToasterService.Error('Something went wrong. Please try again later.');
          navigate(-1);
        }
      } else {
        const payloadNewAdd = {
          customer_id: customerId.current,
          address_line_1: formData.address1,
          address_line_2: formData.address2,
          city: formData.city,
          state: formData.state,
          pincode: formData.pincode,
          country: formData.country,
          is_primary_address: '0',
          is_shipping_address: '1',
          // is_shipping_address: String(formData.shippingAddress),
        };
        console.log('payloadNewAdd', payloadNewAdd);
        const resp = await UserService.CreateAddress(payloadNewAdd);
        if (resp && resp.message && resp.message.status === STATUS_SUCCESS) {
          ToasterService.Success('New Address Created Successfully!.');
          navigate(-1);
        } else if (resp?.exception && resp.exception.includes('Postal Code')) {
          setWrongPincodeError(true);
        } else {
          ToasterService.Error('Something went wrong. Please try again later.');
          navigate(-1);
        }
      }
    } catch (err) {
      setLoading(false);
      ToasterService.Error('Server Error!..');
    }
  };

  const states = {
    errors,
    formData,
    stateList,
    countryList,
    pageTitle,
    wrongPincodeError,
    addressId,
  };

  return {
    handleChange,
    handleSubmit,
    states,
    navigate,
  };
}
